module.exports = __webpack_public_path__ + "media/src/images/keyVisual-47e8d17777c73525786b91e1dddd2dd3.jpg";